function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "5-3-a-standard-secondary_svg__a",
  d: "M8.75 14.25L6 11.5l-1 .999 3.75 3.751L17 7.999 16 7z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 35,
  x: 0.5,
  y: 0.5,
  stroke: "#3899EC",
  rx: 17.5
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7 7)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "5-3-a-standard-secondary_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#5-3-a-standard-secondary_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#162D3D",
  fillRule: "nonzero",
  xlinkHref: "#5-3-a-standard-secondary_svg__a"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#3899EC",
  mask: "url(#5-3-a-standard-secondary_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h22v22H0z"
}))));

function Svg53AStandardSecondary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='36' height='36' viewBox='0 0 36 36'%3E %3Cdefs%3E %3Cpath id='a' d='M8.75 14.25L6 11.5l-1 .999 3.75 3.751L17 7.999 16 7z'/%3E %3C/defs%3E %3Cg fill='none' fill-rule='evenodd'%3E %3Crect width='35' height='35' x='.5' y='.5' stroke='%233899EC' rx='17.5'/%3E %3Cg transform='translate(7 7)'%3E %3Cmask id='b' fill='%23fff'%3E %3Cuse xlink:href='%23a'/%3E %3C/mask%3E %3Cuse fill='%23162D3D' fill-rule='nonzero' xlink:href='%23a'/%3E %3Cg fill='%233899EC' mask='url(%23b)'%3E %3Cpath d='M0 0h22v22H0z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { Svg53AStandardSecondary as ReactComponent };